import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import InPlaceText from 'components/form/in_place_text';
import { DeckStore, PromotionStore } from '@seedlang/stores';
import autobind from 'autobind-decorator';
import UserSearch from 'components/user_search';
import { Link } from 'react-router';
import InPlaceSelect from 'components/form/in_place_select';
import { sortBy } from 'lodash';
import { isPresent } from '@seedlang/utils';
import Copy from 'components/copy';
import Text from 'components/text';
import InfoTooltip from 'components/info_tooltip';
import styled from '@emotion/styled';
import Stack from 'components/layout/stack';
import Grid from 'components/layout/grid';

const InnerRow = styled.div`
  display: flex;
  gap: 5px; 
  align-items: center;
`;

@observer
class PromotionEdit extends React.Component {

  @computed get decks() {
    return sortBy(DeckStore.indexData.filter(item => isPresent(item.concept) && isPresent(item.concept.name)), item => item.concept.name);
  }

  componentDidMount() {
    this.loadPromotion();
    DeckStore.getIndex({ limit: 999, filters: { open_access: true, deck_type: 'concept' } });
  }

  componentWillUnmount() {
    PromotionStore.clearShowData();
  }

  @autobind onUpdateUser(user) {
    PromotionStore.update({ data: { userId: user ? user.id : null }, ids: { promotionId: this.props.params.promotionId } }, this.loadPromotion);
  }

  @autobind loadPromotion() {
    PromotionStore.getShow({ ids: { promotionId: this.props.params.promotionId } }, this.afterGetShow);
  }

  @autobind afterGetShow(resp) {
    PromotionStore.setShowData(resp);
  }

  render() {
    return (
      <Stack gap='sm' alignItems='stretch'>
        {
          PromotionStore.hasShowData &&
          <div>
            <Grid columns={[4, 3, 3, 2]}>
              <InPlaceText
                legend='Name'
                defaultValue={PromotionStore.showData.name}
                model='promotions'
                field='name'
                id={PromotionStore.showData.id}
              />
              <InPlaceText
                legend={<>Slug <InfoTooltip>Appears in the link</InfoTooltip></>}
                id={PromotionStore.showData.id}
                field='slug'
                model='promotions'
                defaultValue={PromotionStore.showData.slug}
                afterChange={this.loadPromotion}
              />
              {
                isPresent(PromotionStore.showData.slug) &&
                <fieldset>
                  <legend>Link</legend>
                  <InnerRow>
                    <input
                      readOnly
                      value={PromotionStore.showData.link}
                      style={{ fontSize: '12px', height: '20px' }}
                    />
                    <Copy
                      className='outline-button blue'
                      text={PromotionStore.showData.link}
                    />
                  </InnerRow>
                </fieldset>
              }
              <fieldset>
                <legend>Created At</legend>
                <Text>{PromotionStore.showData.createdAt.formattedDateWithYear}</Text>
              </fieldset>
            </Grid>
            <Grid columns={4}>
              <fieldset>
                <legend># Visitors</legend>
                {PromotionStore.showData.uniqueVisitorsCount}
              </fieldset>
              <fieldset>
                <legend># Web Signups <InfoTooltip>Number of people who created an account on the website (even as guest).</InfoTooltip></legend>
                {PromotionStore.showData.signedUpWithCount}
              </fieldset>
              <fieldset>
                <legend># Web Conversions <InfoTooltip>Users who took a subscription.</InfoTooltip></legend>
                {PromotionStore.showData.conversions}
              </fieldset>
              <fieldset>
                <legend>Web Conversion %<InfoTooltip>Percentage of users who took a subscription.</InfoTooltip></legend>
                {PromotionStore.showData.conversionPercentage.toFixed(2)}%
              </fieldset>
            </Grid>
            <Grid columns={3} style={{ marginTop: '100px' }}>
              <InPlaceText
                legend='Discount'
                id={PromotionStore.showData.id}
                field='discount'
                model='promotions'
                defaultValue={PromotionStore.showData.discount}
              />
              <fieldset>
                <legend>User [Legacy]</legend>
                {
                  !PromotionStore.showData.user &&
                  <UserSearch
                    onSubmit={this.onUpdateUser}
                    placeholder='Search for User'
                    displayField='name'
                  />
                }
                {
                  PromotionStore.showData.user &&
                  <div>
                    <Link
                      to={{ name: 'builder.users.edit', params: { userId: PromotionStore.showData.user.id } }}
                    >
                      {PromotionStore.showData.user.name}
                    </Link>
                    <i
                      className='fa fa-times fa-on-click'
                      style={{ margin: '3px 0 0 3px' }}
                      onClick={() => this.onUpdateUser()}
                    />
                  </div>
                }
              </fieldset>
              <fieldset>
                <legend>Deck [Legacy]</legend>
                <InPlaceSelect
                  id={PromotionStore.showData.id}
                  field='deck_id'
                  model='promotions'
                  value={PromotionStore.showData.deck && PromotionStore.showData.deck.id}
                  includeBlank
                  options={this.decks.map(item => [item.id, item.concept ? item.concept.name : ''])}
                  afterChange={this.loadPromotion}
                />
              </fieldset>
            </Grid>
          </div>
        }
      </Stack>
    );
  }
}

export default PromotionEdit;
